<script>
import { useI18n } from 'vue-i18n';
import { computed } from 'vue';
import AboutFreelance from './AboutFreelance.vue';

export default {
	components: {
		AboutFreelance
	},
	setup() {
		const { tm } = useI18n();
		const experience = computed(() => tm('about.experience').map((item, index) => ({
			...item,
			img: index === 0 ? require('@/assets/images/experience/techno.jpg') : require('@/assets/images/experience/diskominfojpr.jpg')
		})));
		const education = computed(() => tm('about.education').map((item, index) => ({
			...item,
			img: index === 0 ? require('@/assets/images/experience/telkomuniv.jpg') : require('@/assets/images/experience/m2k.jpg')
		})));
		return {
			experience,
			education
		};
	},
};
</script>

<template>
  <div class="block sm:flex sm:gap-1 mt-10 sm:mt-20 bg-primary-light dark:bg-ternary-dark shadow-sm">
    <!-- Experience -->
    <div class="container w-full mx-auto py-10">
      <p class="text-left w-1/2 font-general-bold text-3xl text-secondary-dark dark:text-secondary-light mb-5">
        Experience
      </p>
      <section
        v-for="(job, index) in experience"
        :key="index"
      >
        <div class="flex flex-row mb-2">
          <div>
            <img
              :src="job.img"
              class="rounded-xl w-12"
            >
          </div>	
          <div>
            <h2 class="text-start font-general-bold text-2xl text-secondary-dark dark:text-secondary-light mb-2 pt-2 pl-4">
              {{ job.company }}
            </h2>
          </div>
        </div>	
        <div class="w-full mb-7 sm:mb-0">
          <div class="w-full mb-7 sm:mb-0">
            <div class="mb-7">
              <p class="text-left font-general-medium text-xl text-ternary-dark dark:text-ternary-light mb-2">
                {{ job.position }}
              </p>
              <p class="text-left font-general-regular text-md text-primary-dark dark:text-ternary-light">
                {{ job.startDate }} - {{ job.endDate }}
              </p>
              <p
                class="text-left font-general-regular text-md text-primary-dark dark:text-ternary-light mt-2"
              >
                {{ job.description }}
              </p>
            </div>
          </div>
        </div>
      </section>
      <AboutFreelance />
    </div>
    <div class="container w-full mx-auto py-10">
      <p class="text-left w-1/2 font-general-bold text-3xl text-secondary-dark dark:text-secondary-light mb-5">
        Education
      </p>
      <section
        v-for="(edu, index) in education"
        :key="index"
      >
        <div class="flex flex-row mb-2">
          <div>
            <img
              :src="edu.img"
              class="inline w-12 rounded-xl"
            >
          </div>	
          <div>
            <h2 class="text-left font-general-bold text-2xl text-secondary-dark dark:text-secondary-light mb-2 pt-0 pl-4">
              {{ edu.school }}
            </h2>
          </div>
        </div>		
        <div class="w-full mb-7 sm:mb-0">
          <div class="w-full mb-7 sm:mb-0">
            <p class="text-left font-general-medium text-lg text-ternary-dark dark:text-ternary-light mb-2 pt-0">
              {{ edu.major }}
            </p>
            <div class="mb-7">
              <p class="text-left font-general-regular text-md text-primary-dark dark:text-ternary-light">
                Year active: {{ edu.generation }}
              </p>
            </div>
          </div>
        </div>
      </section>
      
    </div>
  </div>
</template>